export enum ProtocolErrorCodes {
  INVALID_VERSION = 1001,
  INVALID_CHECKSUM = 1002,
  UNSUPPORTED_FEATURE = 1003,
  INVALID_MANIFEST = 1004,
  EXPIRED_SESSION = 1005,
  INVALID_PAYLOAD = 1006,
}

export class ProtocolValidationError extends Error {
  code: number = ProtocolErrorCodes.INVALID_VERSION;
  constructor(message: string, code?: number) {
    super(message);
    this.name = 'ProtocolValidationError';
    if (code) this.code = code;
  }
}

export class ProtocolChecksumError extends Error {
  code: number = ProtocolErrorCodes.INVALID_CHECKSUM;
  constructor(message: string) {
    super(message);
    this.name = 'ProtocolChecksumError';
  }
}
